/**
 * Registers the email-domain UI intents (email.openComposer). Idempotent —
 * called once at app startup. Owns the `email.*` namespace (domain ownership).
 */
import { ATTENTION_ROUTES } from '@shared/constants/routes';

import { useEmailComposeRequestStore } from './stores/emailComposeRequestStore';
import { registerIntent } from '../agentUi/uiIntentDispatcher';

let registered = false;

/** Register email.* intent handlers once. */
export function registerEmailIntents(): void {
  if (registered) return;
  registered = true;

  registerIntent('email.openComposer', (args, ctx) => {
    const draftId = args.draft_id;
    if (typeof draftId !== 'string' || !draftId) return; // fail-closed
    useEmailComposeRequestStore.getState().requestOpen(draftId);
    ctx.navigate(ATTENTION_ROUTES.root);
  });
}

/** Test-only: allow re-registration after a dispatcher reset. */
export function __resetEmailIntentRegistrationForTests(): void {
  registered = false;
}
